import React from "react";
import { v4 as uuid } from "uuid";

export default function FieldSection({ anchors, fields, setFields }) {
  const addField = () => {
    setFields([
      ...fields,
      {
        id: uuid(),
        name: "",
        anchorId: "",
        direction: "right"
      }
    ]);
  };

  return (
    <section>
      <h4>Fields</h4>
      <button onClick={addField}>? Add Field</button>

      {fields.map(f => (
        <div key={f.id} style={styles.row}>
          <input
            placeholder="Field Name"
            value={f.name}
            onChange={e =>
              setFields(fields.map(x =>
                x.id === f.id ? { ...x, name: e.target.value } : x
              ))
            }
          />

          <select
            value={f.anchorId}
            onChange={e =>
              setFields(fields.map(x =>
                x.id === f.id ? { ...x, anchorId: e.target.value } : x
              ))
            }
          >
            <option value="">Select Anchor</option>
            {anchors.map(a => (
              <option key={a.id} value={a.id}>{a.text}</option>
            ))}
          </select>

          <select
            value={f.direction}
            onChange={e =>
              setFields(fields.map(x =>
                x.id === f.id ? { ...x, direction: e.target.value } : x
              ))
            }
          >
            <option value="right">Right</option>
            <option value="below">Below</option>
          </select>
        </div>
      ))}
    </section>
  );
}

const styles = {
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "6px",
    marginBottom: "6px"
  }
};
